import Config from "../Config";
import { useRef, useState } from "react";

import xmenu from '../menu.png'
import xmenu_black from '../menu_black.png'

import calendar from '../nav_calendar.png'
import calendar_b from '../calendar.png'
import calendar_z from '../calendar.png'
import clock from '../nav_clock.png'
import clock_b from '../nav_clock_b.png'
import clock_z from '../nav_clock_z.png'
import chat from '../nav_msg.png'
import chat_b from '../nav_msg_b.png'
import chat_z from '../nav_msg_z.png'
import wyprawka from '../nav_bag.png'
import wyprawka_b from '../nav_bag_b.png'
import wyprawka_z from '../nav_bag_z.png'

function EmployeeMenuBottom(props)
{

    
    const showMenu = (e) => {
        props.mainView.changeMenuStatus(1);
    }
    
    const hideMenu = (e) => {
        props.mainView.changeMenuStatus(0);
    }


/*
<span className="menu_bottom_buttons">
                            <img src={clock_b} className="img_white" />
                            <img src={clock} className="img_black" />
                        </span>
*/
    return( 
        
        <div class="menu_bottom">
            {
                props.mainView.menuVisible == 0 &&
                <div className="menu_show_btn link_normal" >
                    <span className="menu_bottom_buttons">
                        <img src={wyprawka_b} module="layette" view="layette" id="" onClick={props.mainView.quickGo} className="img_white" />
                        <img src={wyprawka} module="layette" view="layette" id="" onClick={props.mainView.quickGo} className="img_black" />
                    </span>
                    <span className="menu_bottom_buttons" >
                        <img src={chat_b} className="img_white" module="msg" view="sended" id="" onClick={props.mainView.quickGo} />
                        <img src={chat} className="img_black" module="msg" view="sended" id="" onClick={props.mainView.quickGo} />
                    </span>
                    <span className="menu_bottom_buttons" onClick={showMenu}>
                        <img src={xmenu} className="img_white" />
                        <img src={xmenu_black} className="img_black" />
                    </span>
                    <span className="menu_bottom_buttons">
                        <img src={clock_b}  module="myJobs" view="hour_add" id="" onClick={props.mainView.quickGo} className="img_white" />
                        <img src={clock}  module="myJobs" view="hour_add" id="" onClick={props.mainView.quickGo} className="img_black" />
                    </span>
                    <span className="menu_bottom_buttons">
                        <img src={calendar_b} module="kidsE" view="FreeE" id="" onClick={props.mainView.quickGo}  className="img_white" />
                        <img src={calendar} module="kidsE" view="FreeE" id="" onClick={props.mainView.quickGo}  className="img_black" />
                    </span>
                </div>
            }
                        
            {
                props.mainView.menuVisible == 1 &&
                    <div className="menu_show_btn link_normal"  >
                        <span className="menu_bottom_buttons">
                            <img src={wyprawka_b} className="img_white" module="layette" view="layette" id="" onClick={props.mainView.quickGo} />
                            <img src={wyprawka} className="img_black" module="layette" view="layette" id="" onClick={props.mainView.quickGo} />
                        </span>
                        <span className="menu_bottom_buttons" className="menu_bottom_buttons" >
                            <img src={chat_b} className="img_white" module="msg" view="sended" id="" onClick={props.mainView.quickGo} />
                            <img src={chat} className="img_black" module="msg" view="sended" id="" onClick={props.mainView.quickGo} />
                        </span>
                        <span className="menu_bottom_buttons" onClick={hideMenu}>
                            <img src={xmenu} className="img_white" />
                            <img src={xmenu_black} className="img_black" />
                        </span>
                        <span className="menu_bottom_buttons">
                            <img src={clock_b} module="myJobs" view="hour_add" id="" onClick={props.mainView.quickGo}  className="img_white" />
                            <img src={clock} module="myJobs" view="hour_add" id="" onClick={props.mainView.quickGo}  className="img_black" />
                        </span>
                        <span className="menu_bottom_buttons">
                            <img src={calendar_b} module="kidsE" view="FreeE" id="" onClick={props.mainView.quickGo} className="img_white" />
                            <img src={calendar} module="kidsE" view="FreeE" id="" onClick={props.mainView.quickGo} className="img_black" />
                        </span>
                    </div>
            }
            
        </div>
    )
}


export default EmployeeMenuBottom;